import {CsForm}               from "@Common/react/cs-form/cs-form";
import {emailFormatValidator} from "@Common/react/cs-form/validators/email-format";
import {makeLengthValidator}  from "@Common/react/cs-form/validators/length";
import {required}             from "@Common/react/cs-form/validators/required";
import {Types}                from "@Common/types";

type FormModel = Types.Xpresso.Account.Admin.OfficeManagement.Common.General.FormModel;

export const FIELD_NAMES = [
    "branchAdmin1Email" as const,
    "branchAdmin1Name" as const,
    "branchAdmin2Email" as const,
    "branchAdmin2Name" as const,
    "branchEmail" as const,
    "branchManagerName" as const,
    "branchName" as const,
    "branchPhone1" as const,
    "branchPhone2" as const,
    "branchLinkId" as const,
];

const FIELD_VALIDATORS:{
    [key in typeof FIELD_NAMES[number]] ?: Array<Types.Common.React.CsForm.Validator<FormModel, key>>
} = (() => {
    const maxLength25Validator = makeLengthValidator({max: 25});
    const maxLength40Validator = makeLengthValidator({max: 40});
    const maxLength60Validator = makeLengthValidator({max: 60});
    const maxLength80Validator = makeLengthValidator({max: 80});
    const minLength2Validator = makeLengthValidator({min: 2});
    const phoneFormatValidator = {
        check      : (phone:string) => !phone || phone.replace(/[^0-9]+/g, "").length >= 3,
        getMessage : () => "Please enter a valid phone number",
    };
    return {
        branchAdmin1Email : [emailFormatValidator, maxLength60Validator],
        branchAdmin1Name  : [maxLength40Validator],
        branchAdmin2Email : [emailFormatValidator, maxLength60Validator],
        branchAdmin2Name  : [maxLength40Validator],
        branchEmail       : [required, emailFormatValidator, maxLength60Validator],
        branchManagerName : [maxLength40Validator],
        branchName        : [required, minLength2Validator, maxLength80Validator],
        branchPhone1      : [phoneFormatValidator, maxLength25Validator],
        branchPhone2      : [phoneFormatValidator, maxLength25Validator],
        branchLinkId      : [maxLength60Validator],
    };
})();

export const GeneralFormState = ({branch, next}:{
    branch : FormModel,
    next   : (v:Types.Xpresso.Account.Admin.OfficeManagement.Common.General.FormStateNext) => JSX.Element,
}): React.FunctionComponentElement<any> => (
    CsForm({
        next,
        fields: FIELD_NAMES.map(path => ({
            path,
            defaultValue : branch?.[path],
            validators   : FIELD_VALIDATORS[path],
        })),
    })
);

